export const STATUS_EDIT = 0;　//作業
export const STATUS_REVIEW = 1;　//承認依頼
export const STATUS_REJECT = 2;　//差し戻し
export const STATUS_ACCEPT = 3;　//承認済み
export const STATUS_NONE = 4; //使っていない
export const STATUS_PUBLIC_REVIEW = 5; //配信予約レビュー中
export const STATUS_PUBLIC_REJECT = 6; //配信予約差し戻し
export const STATUS_PUBLIC_ACCEPT = 7; //配信待ち
export const STATUS_PUBLIC_DONE = 8; //配信済み
